import ProgramAssessments from '../../components/ProgramAssessments'
import { createApp } from 'vue';
import BootstrapVueNext from 'bootstrap-vue-next'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'

if (document.getElementById('program-my-napsacc')) {
    const app = createApp({
        components: {
            'assessments': ProgramAssessments
        },
        functions: {
        },
        mounted: function () {
        }
    });
    app.use(BootstrapVueNext);
    app.mount('#program-my-napsacc');
}


